import React, { useState } from 'react';
import { ChevronDown, Search, Download, X } from 'lucide-react';

const FilterSection = ({ selectedYear, onYearChange, searchTerm, onSearchChange, onExport }) => {
  const [isYearDropdownOpen, setIsYearDropdownOpen] = useState(false);

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, i) => currentYear - i);

  const handleExport = () => {
    // Create a dummy export file
    const exportData = `Payslips Export for ${selectedYear}\n\nGenerated on: ${new Date().toLocaleDateString()}\n\nMonths included:\n- January ${selectedYear}\n- February ${selectedYear}\n- March ${selectedYear}\n- April ${selectedYear}\n- May ${selectedYear}\n- June ${selectedYear}\n- July ${selectedYear}\n- August ${selectedYear}\n- September ${selectedYear}\n- October ${selectedYear}\n- November ${selectedYear}\n- December ${selectedYear}\n\nTotal payslips: 12`;

    const blob = new Blob([exportData], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `payslips-export-${selectedYear}.txt`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    if (onExport) onExport();
  };

  return (
    <div className="flex flex-wrap gap-5 justify-between px-6 py-3.5 mt-1.5 w-full whitespace-nowrap bg-white rounded-3xl shadow-[6px_6px_54px_rgba(0,0,0,0.05)] max-md:pr-5 max-md:max-w-full">
      <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto whitespace-normal">
      <div className="flex overflow-visible py-2 pr-7 pl-2 text-gray-400 bg-white rounded shadow-sm border-slate-500 max-md:pr-5 relative">
        <div className="relative z-20">
          <button
            onClick={() => setIsYearDropdownOpen(!isYearDropdownOpen)}
            className="flex gap-9 p-3 text-xs uppercase items-center outline-none bg-white"
            aria-label="Select year"
            aria-expanded={isYearDropdownOpen}
          >
            <span>{selectedYear || 'Year'}</span>
            <ChevronDown size={17} className={`transition-transform ${isYearDropdownOpen ? 'rotate-180' : ''}`} />
          </button>

          {isYearDropdownOpen && (
            <div className="absolute top-full left-0 mt-1 bg-white border border-gray-200 rounded-md shadow-lg z-50 min-w-[100px]">
              {years.map((year) => (
                <button
                  key={year}
                  onClick={() => {
                    onYearChange(year);
                    setIsYearDropdownOpen(false);
                  }}
                  className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 outline-none first:rounded-t-md last:rounded-b-md"
                >
                  {year}
                </button>
              ))}
            </div>
          )}
        </div>

        <div className="flex overflow-hidden gap-4 px-2.5 py-1 my-auto text-xs bg-white border-l border-gray-200">
          <Search size={20} className="text-gray-400" />
          <input
            type="text"
            placeholder="Search by month"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="my-auto basis-auto bg-transparent border-none outline-none text-gray-700 placeholder-gray-400 min-w-[120px]"
            aria-label="Search payslips by month"
          />
        </div>
      </div>

      {(searchTerm || selectedYear !== currentYear) && (
        <button
          type="button"
          onClick={() => {
            onSearchChange("");
            onYearChange(currentYear);
          }}
          className="flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium text-red-600 border border-red-200 bg-red-50 hover:bg-red-100 transition whitespace-nowrap shrink-0 w-full sm:w-auto"
        >
          <X size={14} />
          Clear Filters
        </button>
      )}
      </div>

      <button
        onClick={handleExport}
        className="flex gap-2 items-center px-10 py-2.5 my-auto text-sm font-medium leading-none rounded-lg border border-solid border-slate-300 text-sky-950 hover:bg-gray-50 outline-none transition-colors max-md:pl-5"
        aria-label="Export payslips"
      >
        <Download size={16} className="text-sky-950" />
        <span>Export</span>
      </button>
    </div>
  );
};

export default FilterSection;
